// extracted by mini-css-extract-plugin
export default {"button":"OnOffButton_button__9DzT4","buttonMobile":"OnOffButton_buttonMobile__IzLrC","buttonOn":"OnOffButton_buttonOn__DAayF"};